import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { withRouter } from 'react-router'
import { AuthRedux } from 'auth-advenio'
import { MsalContext } from '@azure/msal-react'
import { MainNav, LeftDrawer, SearchBar, Colors, Title2 } from 'advenio-components'
import UsersActions from '@redux/UsersRedux'
import CompaniesActions from '@redux/CompaniesRedux'
import CountriesActions from '@redux/CountriesRedux'
import RegimenFiscalActions from '../Data/Redux/RegimenFiscalRedux'
import CentersActions from '../Data/Redux/CentersRedux'
import { getPlatformLink, SENTRY_ENV } from '../config'
import { defaultProfileImage } from '../Constants'


const TituloQA = styled.div`
  width:100%;

  h1 {
    display: flex;
    justify-content: center;
  }
`
class Layout extends Component {
  static contextType = MsalContext

  state = {
    isDrawerOpen: false,
    platforms: [],
    activePlatformIndex: 0,
  }

  componentWillMount() {
    // TODO: Refactor this - it has terrible performance implications.
    // We don't want to rely on having the user object stored in the props for every section
    // of the app. It would be better to do this once from AppContainer and store the result
    // in the user redux store.
    const { user, getUsers, getCountries, getPaymentTypes, getRegimenFiscal, getCenters } = this.props
    getUsers()
    getCountries()
    getPaymentTypes()
    getRegimenFiscal()
    getCenters()
    if (user) {
      let activePlatformIndex = 0

      const platforms = user.platform_permissions.map((platform, index) => {
        if (platform === 'Companies') {
          activePlatformIndex = index
        }

        return {
          id: index,
          name: platform,
          link: platform.toLowerCase(),
        }
      })

      this.setState({ platforms, activePlatformIndex })
    }
  }

  componentDidMount() {
    const { postUserPicture, user: { id, profile_pictures }, loadingPic } = this.props
    const blobObj = localStorage.getItem('image_profile') || null
    if (profile_pictures === null && blobObj !== null) {
      postUserPicture(id, { profile_pic: blobObj })
    }
  }

  getBannerQA = () => SENTRY_ENV !== 'production' ? <TituloQA><Title2>AMBIENTE PRUEBAS</Title2></TituloQA> : null

  /**
   * Fired after a new page is selected. Receives the link to be navigated to.
   */
  onPageSelected = link => this.props.goTo(link)

  /**
   * Fired after a new platform is selected. Receives the link to be navigated to.
   */
  onPlatformSelected = link => window.location.assign(getPlatformLink(link))

  /**
   * Log out from the platform
   */
  logout = () => {
    if (this.context.accounts.length > 0) {
      this.context.instance.logoutPopup({
        postLogoutRedirectUri: '/',
        // mainWindowRedirectUri:"/login"
      }).then(() => this.props.logout())
    } else {
      this.props.logout()
    }
  }
  /**
   * Toggle the menu drawer
   */
  toggleSidebar = () => this.setState({
    isDrawerOpen: true,
  })

  pages = () => (
    [
      { id: 1, name: 'Empresas', link: '/' },
    ]
  )

  getProfileImage = () => {
    const { postUserPicture, user: { id }, loadingPic } = this.props
    const blobObj = localStorage.getItem('image_profile') || defaultProfileImage

    return blobObj
  }

  render() {
    const { slot, goHome, match, user: { first_name, profile_pictures } } = this.props
    const { isDrawerOpen, platforms, activePlatformIndex } = this.state

    return (
      <div>
        <MainNav
          platform={'Empresas'}
          toggleSidebar={this.toggleSidebar}
          userName={first_name}
          searchBar={<SearchBar />}
          onLogoClick={goHome}
          onMenuClick={() => this.setState({ isDrawerOpen: true })}
          backgroundColor={Colors.green500}
          profilePicture={profile_pictures !== null ? profile_pictures['thumb-md'] : this.getProfileImage()}

        />
        {/* TODO: Add platforms array to API to retrieve dynamically */}
        { this.getBannerQA()}
        <LeftDrawer
          isOpen={isDrawerOpen}
          onCloseCallback={() => this.setState({ isDrawerOpen: false })}
          userName={first_name}
          selectedPage={match.path}
          pages={this.pages()}
          onPageSelected={this.onPageSelected}
          platforms={platforms}
          onPlatformSelected={this.onPlatformSelected}
          selectedPlatform={activePlatformIndex}
          logout={this.logout}
          profilePicture={profile_pictures !== null ? profile_pictures['thumb-md'] : this.getProfileImage()}
        />
        {slot}
      </div>
    )
  }
}

Layout.propTypes = {
  /** Slot for inserting content into the main layout */
  slot: PropTypes.node.isRequired,
  /** The authenticated User */
  user: PropTypes.object.isRequired,
  /** Data attributes from the current URI */
  match: PropTypes.object,

  /** Navigate to the app root */
  goHome: PropTypes.func.isRequired,
  /** Navigate to the given URL path */
  goTo: PropTypes.func.isRequired,
  /** Log out of the platform */
  logout: PropTypes.func.isRequired,

  stopImpersonateUser: PropTypes.func.isRequired,
}

Layout.defaultProps = {
  match: {},
  user: {},
}

const mapStateToProps = ({ auth: { user }, users }) => ({
  users: users.get.results,
  user,
})

const mapDispatchToProps = dispatch => ({
  goHome: () => dispatch(push('/')),
  goTo: path => dispatch(push(path)),
  logout: () => dispatch(AuthRedux.Actions.logout({ shouldDeleteCookies: true })),
  stopImpersonateUser: () => dispatch(AuthRedux.Actions.stopImpersonateUserRequest()),
  getUsers: () => dispatch(UsersActions.getRequest()),
  getPaymentTypes: () => dispatch(CompaniesActions.getPaymentTypesRequest()),
  getCountries: () => dispatch(CountriesActions.getRequest()),
  getRegimenFiscal: () => dispatch(RegimenFiscalActions.getRequest()),
  postUserPicture: (id, data) => dispatch(UsersActions.postUserPicutreRequest(id, data)),
  getCenters: () => dispatch(CentersActions.getRequest()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout))



// WEBPACK FOOTER //
// ./src/Containers/Layout.jsx